var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "folder_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#folder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.413 8H7.648c-.982 0-1.836.312-2.56.937C4.361 9.56 4 10.35 4 11.306v6.386c0 .07.018.128.053.173a.457.457 0 00.14.116l1.945-6.498c.121-.389.343-.7.666-.937a1.784 1.784 0 011.077-.354h12.861c.613 0 1.1.244 1.459.731.36.487.454 1.019.284 1.594l-1.723 5.74a1.689 1.689 0 01-.642.904c-.313.226-.661.339-1.043.339H4.25c-.486 0-.899-.17-1.24-.51-.34-.341-.51-.754-.51-1.24V6.308c0-.486.18-.909.54-1.269.359-.36.782-.539 1.268-.539H9.05c.241 0 .473.047.695.14.223.094.416.223.58.387L11.798 6.5h7.894c.448 0 .834.145 1.158.434.324.289.512.644.563 1.066z",
    fill: "#17BED0"
  }))));
}
export default SvgFolder;